<template>
    <div>
      <ad></ad>
      <div class="content">
        <inner-nav :innerData="innerData" :innerTitle="innerTitle"></inner-nav>
        <div class="msg">
          未能找到关于"<span>{{title}}</span>"的搜索结果
        </div>
      </div>

    </div>
    <!--<someComponent></someComponent>-->
</template>

<script>
    import ad from '../components/advertisement'
    import InnerNav from '../components/innerNav'
    export default {
      name: "",
      data(){
        return {
          innerData:'',
          innerTitle: "搜索结果页",
          title:''
        }
      },
      components: {
        ad,
        InnerNav
      },
      mounted(){
        this.title=this.$route.query.title;
      },
      watch:{
        '$route'(to, from) {
          this.title=to.query.title;
        }
      }
    }
</script>

<style scoped lang="less">
  .content{
    height:calc(100vh - 3.6rem);
  }
  .msg{
    width:100%;
    height:2rem;
    line-height:2rem;
    border-bottom: 1px solid #cccccc;
    text-align: center;
      span{
        color:red;
      }

  }

</style>



// WEBPACK FOOTER //
// src/pages/searchResult.vue